import Header from '../components/Header';
import Footer from '../components/Footer';
import { FileText, AlertTriangle } from 'lucide-react';

const TermsConditions = () => {
  const currentDate = new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-32 pb-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <article className="glass-strong rounded-3xl p-8 md:p-12">
            <div className="flex items-center space-x-3 mb-8">
              <FileText className="w-8 h-8 text-green-600" />
              <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent">
                Terms & Conditions
              </h1>
            </div>

            <div className="mb-6 text-sm text-gray-600">
              <p>Last Updated: {currentDate}</p>
            </div>

            <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
              <p className="text-xl text-gray-800 font-medium">
                These Terms and Conditions govern your access to and use of the Crown Jackpot website (crown-jackpot.com). By accessing or using our website, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our website.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Acceptance of Terms</h2>

              <p>
                By accessing, browsing, or using this website, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions and to comply with all applicable laws and regulations. If you do not agree with any part of these terms, you must not use our website.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Use of Website</h2>

              <p>
                You may use our website for lawful purposes only. You agree not to use the website in any way that violates applicable laws, regulations, or the rights of others. You must not use our website to transmit any harmful code, viruses, or malicious software, attempt to gain unauthorized access to any part of the website, or interfere with the website's operation or security.
              </p>

              <p>
                You are responsible for maintaining the confidentiality of any account information and passwords you may use to access certain features of our website. You agree to notify us immediately of any unauthorized use of your account or any other breach of security.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Age Restrictions</h2>

              <p>
                Our website is intended for users who are 18 years of age or older. By using this website, you represent and warrant that you are at least 18 years old. If you are under 18, you must not use this website. We reserve the right to verify your age and may restrict access to anyone who does not meet age requirements.
              </p>

              <div className="glass p-6 rounded-2xl my-8 border-l-4 border-pink-500">
                <div className="flex items-start space-x-3">
                  <AlertTriangle className="w-6 h-6 text-pink-600 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-bold text-gray-800 mb-2">Important Notice</h3>
                    <p className="text-gray-700">
                      This website contains information about online gambling. Gambling can be addictive and harmful. Please gamble responsibly and within your means. If you need help with problem gambling, visit BeGambleAware.org or contact GamCare for support.
                    </p>
                  </div>
                </div>
              </div>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Intellectual Property</h2>

              <p>
                All content on this website, including text, graphics, logos, images, audio clips, digital downloads, and software, is the property of Crown Jackpot or its content suppliers and is protected by UK and international copyright laws. You may not reproduce, distribute, modify, create derivative works, publicly display, or otherwise use any content from this website without our prior written permission.
              </p>

              <p>
                The Crown Jackpot name, logo, and all related names, logos, product and service names, designs, and slogans are trademarks of Crown Jackpot or its affiliates. You may not use such marks without our prior written permission.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">User Content</h2>

              <p>
                If you submit any content to our website, including comments, reviews, or other materials, you grant us a non-exclusive, royalty-free, perpetual, irrevocable, and fully sublicensable right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display such content throughout the world in any media.
              </p>

              <p>
                You represent and warrant that you own or have the necessary rights to the content you submit and that your content does not violate any third-party rights or applicable laws. We reserve the right to remove any content that we deem inappropriate, offensive, or in violation of these Terms and Conditions.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Affiliate Relationships</h2>

              <p>
                We maintain affiliate relationships with some of the online casinos we review and recommend. This means we may receive commissions when you click on links to these casinos or sign up through our website. However, our affiliate relationships do not influence our editorial independence, review processes, or recommendations.
              </p>

              <p>
                We maintain strict editorial standards and only recommend casinos that meet our rigorous criteria, regardless of affiliate relationships. Our reviews and ratings are based solely on our independent testing and analysis, not on commercial considerations.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Disclaimer of Warranties</h2>

              <p>
                Our website and its content are provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that the website will be uninterrupted, secure, or error-free, or that any defects will be corrected. We do not warrant the accuracy, completeness, or usefulness of any information on the website.
              </p>

              <p>
                We are not responsible for the content, privacy practices, or terms of third-party websites linked from our website. Your use of third-party websites is at your own risk and subject to their terms and conditions.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Limitation of Liability</h2>

              <p>
                To the fullest extent permitted by law, Crown Jackpot and its affiliates, officers, directors, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our website.
              </p>

              <p>
                Our total liability to you for all claims arising from or related to your use of the website shall not exceed the amount you paid to us, if any, in the 12 months preceding the claim.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Indemnification</h2>

              <p>
                You agree to indemnify, defend, and hold harmless Crown Jackpot and its affiliates, officers, directors, employees, and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt, and expenses (including reasonable attorney's fees) arising from your use of the website, your violation of these Terms and Conditions, or your violation of any rights of another party.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Modifications to Terms</h2>

              <p>
                We reserve the right to modify these Terms and Conditions at any time. We will notify you of any material changes by posting the updated terms on this page and updating the "Last Updated" date. Your continued use of the website after such modifications constitutes your acceptance of the updated terms.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Termination</h2>

              <p>
                We reserve the right to terminate or suspend your access to our website at any time, with or without cause or notice, for any reason, including if you breach these Terms and Conditions. Upon termination, your right to use the website will immediately cease.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Governing Law</h2>

              <p>
                These Terms and Conditions shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions. Any disputes arising from or relating to these terms or your use of the website shall be subject to the exclusive jurisdiction of the courts of England and Wales.
              </p>

              <h2 className="text-3xl font-bold text-gray-800 mt-8 mb-4">Contact Information</h2>

              <p>
                If you have questions about these Terms and Conditions, please contact us at:
              </p>

              <div className="glass p-6 rounded-2xl my-6">
                <p className="font-semibold text-gray-800 mb-2">Crown Jackpot</p>
                <p className="text-gray-700">Email: info@crown-jackpot.com</p>
                <p className="text-gray-700">Phone: +44 9296 526 586</p>
                <p className="text-gray-700">Address: London, United Kingdom</p>
              </div>
            </div>
          </article>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsConditions;

